/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator");
    }

    getFixupPrototypeFunction() { return AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator {
        let obj = Object.assign(new AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator(), model);
        AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator>): AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator {
        if (!model) return null;
        return AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.newInstance(<AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator) {
        if (!obj) return;

        models.AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsVulnerabilityImpactMetricIntegrityImpactV31QueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Impact metric(s) integrity impact to include
     */
    integrity_impact_v31: Array<models.CvssV31ImpactMetrics>;

}
